import AuthenticationLayout from 'components/AuthLayout';
import { FC } from 'react';
import MentorChart from './MentorChart';

const SignChart: FC = () => {
  return (
    <AuthenticationLayout
      title="Signature de la charte (3/3)"
      backTo="/mentor/fill-form"
      src_image="/logo_institut_mentorat.png"
    >
      <MentorChart />
    </AuthenticationLayout>
  );
};

export default SignChart;
